import LikedArtwork from './LikedArtwork';

export default LikedArtwork;
